import React from 'react';
import {
  Container as Grid,
  Button,
} from 'reactstrap';

import ImgToolkitBg from 'Public/img/homepage/toolkit_bg.png';
import ImgBackground from 'Public/img/homepage/background.png';

import {Link} from 'react-router-dom';
import * as helper from 'App/util/common/helper';
import classNames from 'classnames';
import PrevalenceMap from './PrevalenceMap';
import {
  PatientStatistics,
  Imprint,
  LivingStatus,
  Age18,
  IgReplacement,
  HSCTReplacement,
  GenderChart,
    Gender,
  GenderChartPublic,
  PIDDistribution
} from './Sections';

import {graphql} from 'react-apollo/index';
import gql from 'graphql-tag';
import {renderForError, renderWhileLoading, combineQueries} from 'App/util/recompose/graphql';
import {compose} from 'recompose';
import Loading from 'App/components/Loading';
import GeneTherapy from 'App/views/Pages/Homepage/Sections/GeneTherapy';
import ExternalCenters from "./";


export class HomepageSection extends React.Component {
  render() {
    return (
      <div {...this.props}
           className={classNames(this.props.className,
             'homepage-section')}>
        <Grid>
          {this.props.children}
        </Grid>
      </div>
    );
  }
}

export class HomepageSectionHeader extends React.Component {
  render() {
    return (
      <div {...this.props}
           className={classNames(this.props.className,
             'homepage-section-header')}>
        {this.props.children}
      </div>
    );
  }
}

export class HomepageSectionHeader2 extends React.Component {
  render() {
    return (
      <div {...this.props}
           className={classNames(this.props.className,
             'homepage-section-header2')}>
        {this.props.children}
      </div>
    );
  }
}

class HomepageLoader extends  React.Component {
  render() {
    return (
      <div className="text-center">
        <Loading />
        <span>Loading</span>
      </div>
    );
  }
}

@compose(
  graphql(
    gql `
      {
        homepages_ages_18s {
          geq_18
          iso2
          country
          n
        }
      }
    `,
    {name: 'qry_ages_18'}
  ),
  graphql(gql`
    {
      homepages_patients_therapies_counts(
        order: {column: "count", direction:desc}
      ) {
        gene_therapy
        count
        hsct
      }
    }`,
    {name: 'qry_hsct'}
  ),
  graphql(gql`
    {
      generals_pids_distributions {
        gene
        pid
        main_category_id
        main_category
        sub_category
        sub_category_id
        count
      }
    }`,
    {name: 'qry_pid_distribution'}
  ),
  graphql(
    gql `
      {
        homepages_igs_counts(
          order: {column: "count", direction:desc}
        ) {
          route
          place
          count
        }
      }
    `,
    {name: 'qry_ig_count'}
  ),
  graphql(
    gql `
      {
        homepage_stat {
          imported
          total
          not_yet_verified
        }
      }
    `,
    {name: 'qry_stats'}
  ),
  graphql(
    gql `
      {
        homepages_livings_statuses_counts(
          order: {column: "count", direction:desc}
        ) {
          count
          living_status
        }
      }
    `,
    {name: 'qry_living_status'}
  ),
  graphql(
    gql`
    {
      generals_genders_distributions {
        count
        gender
      }
    }`,
     {name: 'general_gender'}
   ),
  combineQueries(),
  renderWhileLoading('data', HomepageLoader),
  renderForError(),
)
class Homepage extends React.Component {
  render() {
    return (
      <div id='homepage-container' className={classNames('animated', 'fadeIn')}>
        <Button color="primary" tag={Link} to={helper.getPath()} id='demo-btn'>Go To Member Area</Button>
        <div>
          <HomepageSection className='text-center d-none d-sm-block' style={{
            height: 285,
            backgroundImage: 'url(' + ImgBackground + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            overflow: 'hidden'
          }}>
            <img src={ImgToolkitBg} style={{marginTop: 5}}/>
            <h1>Framework for Registries and Medical Databases</h1>
          </HomepageSection>
          <HomepageSection className='text-center d-block d-sm-none' style={{
            height: 190,
            backgroundImage: 'url(' + ImgBackground + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            overflow: 'hidden'
          }}>
            <img width='270' className='d-block d-sm-none' src={ImgToolkitBg} style={{margin: 'auto', marginTop: 30}}/>
          </HomepageSection>
        </div>
        <PatientStatistics lastUpdated={this.props.lastUpdated} data={this.props.qry_stats.homepage_stat} />
        <LivingStatus data={this.props.qry_living_status.homepages_livings_statuses_counts} />
        <Age18 data={this.props.qry_ages_18.homepages_ages_18s} />
        <IgReplacement data={this.props.qry_ig_count.homepages_igs_counts} />
        <PIDDistribution data={this.props.qry_pid_distribution.generals_pids_distributions} />
        <Gender data={this.props.general_gender.general_gender} />


        <HomepageSection style={{position: 'relative', zIndex: 2}}>
          <HomepageSectionHeader2>
            <h2><span>{'Prevalence Map '}</span></h2>
          </HomepageSectionHeader2>
          <div style={{marginTop: 25, marginBottom: 25}}>
            <PrevalenceMap/>
          </div>
        </HomepageSection>

        <HSCTReplacement data={this.props.qry_hsct.homepages_patients_therapies_counts} />
        <GeneTherapy data={this.props.qry_hsct.homepages_patients_therapies_counts}/>
        <Imprint/>
      </div>
    );
  }
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Homepage.js